import * as React from 'react';
import { StandaloneChatWidgetDesktop } from '@cian/newbuilding-chat-component';
import { useSelector, useDispatch } from 'react-redux';

import { chatToggleOpen } from '../../actions/consultantChat';
import { useWebimProps } from '../../hooks/useWebimProps';
import { isConsultantChatOpenedSelector } from '../../selectors/consultantChat';
import { selectMessageButtonAvailable } from '../../selectors/messageButton';
import { trackClickChatClose } from './tracking';
import { getNewbuildingId } from '../../selectors/newbuilding';

export function ConsultantChatContainer() {
  const dispatch = useDispatch();

  const isMessageButtonAvailable = useSelector(selectMessageButtonAvailable);
  const isOpen = useSelector(isConsultantChatOpenedSelector);
  const newbuildingId = useSelector(getNewbuildingId);

  const webimProps = useWebimProps();

  const handleClose = React.useCallback(() => {
    dispatch(chatToggleOpen(false));
    trackClickChatClose(newbuildingId);
  }, [dispatch, newbuildingId]);

  if (!isMessageButtonAvailable) {
    return null;
  }

  return <StandaloneChatWidgetDesktop webimProps={webimProps} open={isOpen} onClose={handleClose} />;
}
